import { Classes } from '@/imports-files/components/modal';

function Modal(props){

  //const {classname} = props;

    return(
        <>
          <div className={`Modal ${Classes.Modal}`} style={props.style}>{props.children}</div>
        </>
    )
}

export default Modal;
